import React, { PureComponent } from 'react';
import moment from 'moment';
import { createContainer } from '@dbk-legacy/muster/react';
import Button from '@dbk/ui-buttons';
import Text from '@dbk/ui-text';
import { List, ListItem } from '@dbk/ui-list';
import Dropdown from '@dbk/ui-dropdowns';
import { LoadingCircle } from '../../components/common/loading';
import { TextInput, Message } from '@dbk/ui-forms';
import { PALETTE, DOC_STATUS_MAPPING, PAGE, FILTER_MODAL_FIELD_NAME, DATE_FORMATS } from '../../constants';
import { Search } from '@dbk/ui-icons';
import { addDays, addMonths, dateDiff, ymd } from '../../utils/date';
import FilterModalInputField from './filter-modal-input-field';


function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const uniq = require('lodash/uniq');

const labelStyle = {
  color: PALETTE.secondaryText,
  marginBottom: 10
};

const docStatusList = DOC_STATUS_MAPPING.map(e => ({
  label: e.displayValue,
  value: e.status
}))
const EMPTY_STRING = "empty";

const defSelFrom = addDays(1, new Date());
const defSelTo = addDays(7, new Date());
const defaultStartDay = addMonths(-1, new Date());
const defaultEndDay = addMonths(6, new Date());

class FilterModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      documentName: '',
      orderId: '',
      clientName: '',
      rmName: '',
      isLoading: false,
      pfId: '',
      documentType: '',
      rmTeam: '',
      signedDate: {
        from: null,
        to: null
      },
      uploadDate: {
        from: null,
        to: null
      },
      docStatus: '',
      dueDate: {
        from: null,
        to: null
      },
      showOrderIdList: false,
      showRmNameList: false,
      showClientNameList: false,
      showDocumentNameList: false,
      enableApply: false,
      noClientName: false,
      noOrderId: false,
      noRmName: false,
      noDocumentName: false,
      renderErrorBlockDocumentName: false,
      renderErrorBlockOrderId: false,
      renderErrorBlockRmName: false,
      renderErrorBlockClientName: false,
      rmNameListArray: [],
      clientNameListArray: [],
      orderIdListArray: [],
      documentNameListArray: []
    }

  }

  componentDidMount() {
    const { docsigncenter: { retainFilterData } } = this.props;
    const data = retainFilterData ? retainFilterData : this.state;
    this.setState({
      ...data,
      enableApply: false
    })
  }

  componentDidUpdate(prevProps, prevState) {

    const {
      docsigncenter: {
        searchedRmNameList,
        searchedClientNameList,
        searchedOrderIdList,
        searchedDocumentNameList
      }
    } = this.props;

    if (prevProps.docsigncenter.searchedRmNameList !== searchedRmNameList && searchedRmNameList !== undefined) {
      if (searchedRmNameList.rmNameResponse) {
        this.setState({ showRmNameList: true })
      }
      this.setState({ isLoading: false })
    }

    if (prevProps.docsigncenter.searchedClientNameList !== searchedClientNameList && searchedClientNameList !== undefined) {
      if (searchedClientNameList.clientNameResponse) {
        this.setState({ showClientNameList: true })
      }
      this.setState({ isLoading: false })
    }

    if (prevProps.docsigncenter.searchedOrderIdList !== searchedOrderIdList && searchedOrderIdList !== undefined) {
      if (searchedOrderIdList.orderIdResponse) {
        this.setState({ showOrderIdList: true })
      }
      this.setState({ isLoading: false })
    }

    if (prevProps.docsigncenter.searchedDocumentNameList !== searchedDocumentNameList && searchedDocumentNameList !== undefined) {
      if (searchedDocumentNameList.documentNameResponse) {
        this.setState({ showDocumentNameList: true })

      }
      this.setState({ isLoading: false })
    }


  }
  lengthListCheck = key => this.state[key].length >= 4 && this.state[`${key}ListArray`] && this.state[`${key}ListArray`].length > 0 ? this.state[key] : null;

  dateChecker = (key, key2) => this.state[key][key2] ? this.state[key][key2].format(DATE_FORMATS.displayDate) : null

  returnFilter = () => ({
    documentType: this.state.documentType,
    documentName: this.lengthListCheck(FILTER_MODAL_FIELD_NAME.DOCUMENT_NAME),
    orderId: this.state[`orderIdListArray`] && this.state[`orderIdListArray`].length > 0 ? this.state.orderId : null,
    clientName: this.lengthListCheck(FILTER_MODAL_FIELD_NAME.CLIENT_NAME),
    uploadDateFrom: this.dateChecker(FILTER_MODAL_FIELD_NAME.UPLOAD_DATE, FILTER_MODAL_FIELD_NAME.FROM),
    uploadDateTo: this.dateChecker(FILTER_MODAL_FIELD_NAME.UPLOAD_DATE, FILTER_MODAL_FIELD_NAME.TO),
    dueDateFrom: this.dateChecker(FILTER_MODAL_FIELD_NAME.DUE_DATE, FILTER_MODAL_FIELD_NAME.FROM),
    dueDateTo: this.dateChecker(FILTER_MODAL_FIELD_NAME.DUE_DATE, FILTER_MODAL_FIELD_NAME.TO),
    signedDateFrom: this.dateChecker(FILTER_MODAL_FIELD_NAME.SIGNED_DATE, FILTER_MODAL_FIELD_NAME.FROM),
    signedDateTo: this.dateChecker(FILTER_MODAL_FIELD_NAME.SIGNED_DATE, FILTER_MODAL_FIELD_NAME.TO),
    portfolioId: this.state.pfId,
    rmName: this.lengthListCheck(FILTER_MODAL_FIELD_NAME.RM_NAME),
    rmTeam: this.state.rmTeam,
    status: this.state.docStatus

  })

  handleApply = () => {
    let counter = 0;

    const filterO = this.returnFilter();


    const refactorFilterOptions = filteroptions => ({
      ...filteroptions,
      uploadDateFrom: null,
      dueDateFrom: null,
      signedDateFrom: null
    })

    counter = Object.values(refactorFilterOptions(filterO)).filter(e => e).length;

    counter > 0 ? this.setState({ enableApply: true }) : this.setState({ enableApply: false })

  }

  handleDate = (key, range) => {

    this.setState({

      [key]: {
        ...this.state[key],
        ...range
      }
    }, () => { this.handleApply() });
  }

  onClearClick = () => {
    this.props.setRetainFilterData(null);
    this.setState({
      documentName: '',
      orderId: '',
      clientName: '',
      rmName: '',
      isLoading: false,
      pfId: '',
      documentType: '',
      rmTeam: '',
      signedDate: {
        from: null,
        to: null
      },
      uploadDate: {
        from: null,
        to: null
      },
      docStatus: '',
      dueDate: {
        from: null,
        to: null
      },
      showOrderIdList: false,
      showRmNameList: false,
      showClientNameList: false,
      showDocumentNameList: false,
      enableApply: false,
      noClientName: false,
      noOrderId: false,
      noRmName: false,
      noDocumentName: false,
      renderErrorBlockDocumentName: false,
      renderErrorBlockOrderId: false,
      renderErrorBlockRmName: false,
      renderErrorBlockClientName: false,
    },
      () => {
        this.setState({ enableApply: true });
      })

  }


  convertToDropDown = (values, ...keys) => {

    if (values && values.length && keys.length) {
      if (keys.length === 1) { // no label key, only value key
        return values.map(e => ({
          label: e,
          value: e
        }));
      } // got label key also
      return values.map(e => ({
        label: `${e[keys[1]]}`,
        value: `${e[keys[0]]}`
      }));
    }
    return [];
  }

  onFilterChange = (key, val, handleApply) => {
    this.setState({
      [key]: val
    }, handleApply)
  };

  onSearchClick = key => {

    const camelKey = capitalizeFirstLetter(key);
    this.props[`setSearched${camelKey}List`](undefined);
    const errorKey = `no${camelKey}`

    this.setState({
      isLoading: true,
      [errorKey]: false

    })




    key !== 'orderId' && (this.state[key].length < 4 || !this.state[key]) ? this.setState({
      isLoading: false,
      [errorKey]: true
    }) : this.searchFor(key)

  }

  onApplyClick = () => {

    const filterOptions = this.returnFilter();

    const firstTime = false;

    this.props.onApplyFilter(filterOptions, firstTime)
    this.props.setRetainFilterData(this.state);
  }

  searchFor = key => {

    const camelKey = capitalizeFirstLetter(key);
    const errorBlockKey = `renderErrorBlock${camelKey}`
    this.setState({
      [errorBlockKey]: true,

    })
    this.props[`search${camelKey}`](this.state[key], PAGE.defaultPageNumber, PAGE.pageSize);

  }


  renderListItems = listArray => {
    const clickout = () => {

      this.setState({
        showOrderIdList: false,
        showRmNameList: false,
        showClientNameList: false,
        showDocumentNameList: false,
      })
      window.removeEventListener('click', clickout)


    }
    window.addEventListener('click', clickout)

    return (
      listArray.map(item => {

        return (
          <ListItem testID="listItem-filterModal-test"  >
            {item.value}
          </ListItem>
        )
      })
    );
  }



  handleItemSelected = (index, key) => {


    const camelKey = capitalizeFirstLetter(key);
    const entryKey = `searched${camelKey}List`
    const arraykey = `${key}Response`
    const listKey = `show${camelKey}List`
    const valueval = this.props.docsigncenter[entryKey][arraykey][index]
    const value = valueval;
    this.setState({ [key]: value })
    this.setState({ [listKey]: false })
    this.handleApply();

  }


  render() {
    const {
      i18n: { messages },
      docsigncenter: {
        documentTypeList,
        eligiblePfList,
        rmTeamList,
        searchedRmNameList,
        searchedClientNameList,
        searchedOrderIdList,
        searchedDocumentNameList,
        retainFilterData
      }
    } = this.props;
    let portfolioIdList = [];
    let documentTypeListArray = [];
    let rmTeams = [];
    documentTypeListArray = documentTypeList && documentTypeList !== EMPTY_STRING && this.convertToDropDown(documentTypeList, FILTER_MODAL_FIELD_NAME.TEMPLATE_SID, FILTER_MODAL_FIELD_NAME.TEMPLATE_NAME)
    portfolioIdList = eligiblePfList && eligiblePfList !== EMPTY_STRING && this.convertToDropDown(uniq(eligiblePfList.pfId), FILTER_MODAL_FIELD_NAME.PORTFOLIO_ID);
    rmTeams = rmTeamList && rmTeamList !== EMPTY_STRING && this.convertToDropDown(uniq(rmTeamList.rmTeam), FILTER_MODAL_FIELD_NAME.RM_TEAM);
    this.state.rmNameListArray = searchedRmNameList && this.convertToDropDown(searchedRmNameList.rmNameResponse, FILTER_MODAL_FIELD_NAME.RM_NAME_RESPONSE)
    this.state.clientNameListArray = searchedClientNameList && this.convertToDropDown(searchedClientNameList.clientNameResponse, FILTER_MODAL_FIELD_NAME.CLIENT_NAME_RESPONSE)
    this.state.orderIdListArray = searchedOrderIdList && this.convertToDropDown(searchedOrderIdList.orderIdResponse, FILTER_MODAL_FIELD_NAME.ORDER_ID_RESPONSE)
    this.state.documentNameListArray = searchedDocumentNameList && this.convertToDropDown(searchedDocumentNameList.documentNameResponse, FILTER_MODAL_FIELD_NAME.DOCUMENT_NAME_RESPONSE)

    return this.state.isLoading ?
      (< div testID="docSignCenter-filterModal-container"  >


        <LoadingCircle />
      </div>)

      : (<div className="filtermodal">
        <div>
          <div className="row filterRowsMargin">

            {/* Adding one dropdown and text filter */}
            <div className="column large-5 ">
              <div className="field-text">
                <Text style={labelStyle}> {messages['app.docsigncenter.uploadDoc.documentName.label']} </Text>
              </div>
              <TextInput
                testID="text-filterModal-documentName-test"
                className='input-field-dimensions'
                size="small"
                maxlength={15}
                minlength={4}
                placeholder={messages['app.docsigncenter.uploadDoc.documentName.placeholder']}
                placeholderTextColor={PALETTE.secondaryActive}
                value={this.state.documentName}
                onChange={text => this.onFilterChange(FILTER_MODAL_FIELD_NAME.DOCUMENT_NAME, text.target.value)}
              />
              <span className='search-icon' onClick={() => { this.onSearchClick(FILTER_MODAL_FIELD_NAME.DOCUMENT_NAME) }} >
                <Search className="search-icon-style " testID="icon-filterModal-search-documentName-test" color={PALETTE.secondaryActive} height='20px' />
              </span>

              {this.state.noDocumentName ? <Message type="error">{messages['app.docsigncenter.filterModal.minLetter']}</Message> : null}

              {this.state.documentNameListArray && this.state.documentNameListArray.length && this.state.renderErrorBlockDocumentName && !this.state.noDocumentName ?

                this.state.showDocumentNameList && this.state.documentName.length >= 4 &&

                <List testID="list-filterModal-documentName-test" className='list-style' onItemSelected={index => this.handleItemSelected(index, FILTER_MODAL_FIELD_NAME.DOCUMENT_NAME)}>
                  {
                    this.renderListItems(this.state.documentNameListArray)
                  }
                </List> : this.state.renderErrorBlockDocumentName && !this.state.noDocumentName && <Message testID="text-filterModal-documentName-errorMessage-test" type="error">{messages['app.docsigncenter.filterModal.recordNotFound']}</Message>
              }
            </div>

            <div className="column large-5 ">
              <div className="field-text">
                <Text style={labelStyle}> {messages['app.docsigncenter.uploadDoc.signedDate.label']} </Text>
              </div>
              <div >
                <FilterModalInputField
                  testID="date-filterModal-documentName-test"
                  type='date'
                  onChange={e => this.handleDate(FILTER_MODAL_FIELD_NAME.SIGNED_DATE, e)}
                  userSelectionStart={this.state.signedDate.from}
                  userSelectionEnd={this.state.signedDate.to}
                  value={this.state.signedDate}
                  defStartDate={moment().add(-1, 'year')}
                  defEndDate={moment()}
                />
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="row filterRowsMargin">
            {/* Adding one dropdown and text filter */}
            <div className="column large-5">
              <div className="field-text">
                <Text style={labelStyle}>  {messages['app.docsigncenter.uploadDoc.documentType.label']} </Text>
              </div>
              <div className="large-12">
                <Dropdown
                  testID="ddn-filterModal-documentType-test"
                  className="large-12"
                  size='large'
                  selected={this.state.documentType}
                  options={documentTypeListArray}
                  defaultLabel={messages['app.docsigncenter.uploadDoc.documentType.placeholder']}
                  onChange={option => {
                    this.onFilterChange(FILTER_MODAL_FIELD_NAME.DOCUMENT_TYPE, option, () => this.handleApply())

                  }}
                />
              </div>
            </div>
            <div className="column large-5 ">
              <div className="field-text">
                <Text style={labelStyle}> {messages['app.docsign.filter.portfolioId']} </Text>
              </div>
              <div >
                <Dropdown
                  testID="ddn-filterModal-portfolioId-test"
                  className="large-12"
                  size='large'
                  selected={this.state.pfId}
                  options={portfolioIdList}
                  defaultLabel={messages['app.docsigncenter.uploadDoc.portfolioId.placeholder']}
                  onChange={option => {
                    this.onFilterChange(FILTER_MODAL_FIELD_NAME.PORTFOLIO_ID, option, () => this.handleApply())
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="row filterRowsMargin">

            {/* Adding one dropdown and text filter */}
            <div className="column large-5 ">
              <div className="field-text">
                <Text style={labelStyle}> {messages['app.docsigncenter.uploadDoc.orderId.label']} </Text>
              </div>
              <TextInput
                testID="text-filterModal-orderId-test"
                className='input-field-dimensions'
                size="small"
                maxlength={15}
                placeholder={messages['app.docsigncenter.uploadDoc.orderId.placeholder']}
                placeholderTextColor={PALETTE.secondaryActive}
                value={this.state.orderId}
                onChange={text => this.onFilterChange(FILTER_MODAL_FIELD_NAME.ORDER_ID, text.target.value)}
              />
              <span className='search-icon' onClick={() => { this.onSearchClick(FILTER_MODAL_FIELD_NAME.ORDER_ID) }} >
                <Search className="search-icon-style " testID="icon-filterModal-search-orderId-test" color={PALETTE.secondaryActive} />
              </span>
              {this.state.orderIdListArray && this.state.orderIdListArray.length && this.state.renderErrorBlockOrderId && !this.state.noOrderId ?

                this.state.showOrderIdList &&

                <List testID="list-filterModal-orderId-test" className='list-style' onItemSelected={index => this.handleItemSelected(index, FILTER_MODAL_FIELD_NAME.ORDER_ID)}>
                  {
                    this.renderListItems(this.state.orderIdListArray)
                  }
                </List> : this.state.renderErrorBlockOrderId && !this.state.noOrderId && <Message type="error">{messages['app.docsigncenter.filterModal.recordNotFound']}</Message>
              }
            </div>

            <div className="column large-5 ">
              <div className="field-text">
                <Text style={labelStyle}> {messages['app.docsign.filter.rmName.label']} </Text>
              </div>
              <TextInput
                testID="text-filterModal-rmName-test"
                className='input-field-dimensions'
                size="small"
                maxlength={15}
                minlength={4}
                placeholder={messages['app.docsign.filter.selectrmName.label']}
                placeholderTextColor={PALETTE.secondaryActive}
                value={this.state.rmName}
                onChange={text => this.onFilterChange(FILTER_MODAL_FIELD_NAME.RM_NAME, text.target.value)}
              />
              <span className='search-icon-right' onClick={() => { this.onSearchClick(FILTER_MODAL_FIELD_NAME.RM_NAME) }} >
                <Search className="search-icon-style " testID="icon-filterModal-search-rmName-test" color={PALETTE.secondaryActive} height='20px' />
              </span>
              {this.state.noRmName ? <Message type="error">{messages['app.docsigncenter.filterModal.minLetter']}</Message> : null}
              {this.state.rmNameListArray && this.state.rmNameListArray.length && this.state.renderErrorBlockRmName && !this.state.noRmName ?

                this.state.showRmNameList && this.state.rmName.length >= 4 &&

                <List testID="list-filterModal-rmName-test" className='list-style' onItemSelected={index => this.handleItemSelected(index, FILTER_MODAL_FIELD_NAME.RM_NAME)}>
                  {
                    this.renderListItems(this.state.rmNameListArray)
                  }
                </List> : this.state.renderErrorBlockRmName && !this.state.noRmName && <Message type="error">{messages['app.docsigncenter.filterModal.recordNotFound']}</Message>
              }
            </div>
          </div>

        </div>
        <div>
          <div className="row filterRowsMargin">

            {/* Adding one dropdown and text filter */}
            <div className="column large-5">
              <div className="field-text">
                <Text style={labelStyle}>  {messages['app.docsign.filter.clientName.label']} </Text>
              </div>
              <div >
                <TextInput
                  testID="icon-filterModal-search-test"
                  className='input-field-dimensions'
                  size="small"
                  maxlength={15}
                  minlength={4}
                  value={this.state.clientName}
                  onChange={text => this.onFilterChange(FILTER_MODAL_FIELD_NAME.CLIENT_NAME, text.target.value)}
                  placeholder={messages['app.docsign.filter.selectClientName.label']}
                  placeholderTextColor={PALETTE.secondaryActive}
                />
                <span className='search-icon' onClick={() => { this.onSearchClick(FILTER_MODAL_FIELD_NAME.CLIENT_NAME) }} >
                  <Search className="search-icon-style " testID="icon-filterModal-search-clientName-test" color={PALETTE.secondaryActive} height='20px' />
                </span>
                {this.state.noClientName ? <Message type="error">{messages['app.docsigncenter.filterModal.minLetter']}</Message> : null}
                {this.state.clientNameListArray && this.state.clientNameListArray.length && this.state.renderErrorBlockClientName && !this.state.noClientName ?

                  this.state.showClientNameList && this.state.clientName.length >= 4 &&

                  <List testID="list-filterModal-clientName-test" className='list-style' onItemSelected={index => this.handleItemSelected(index, FILTER_MODAL_FIELD_NAME.CLIENT_NAME)}>
                    {
                      this.renderListItems(this.state.clientNameListArray)
                    }
                  </List> : this.state.renderErrorBlockClientName && !this.state.noClientName && <Message type="error">{messages['app.docsigncenter.filterModal.recordNotFound']}</Message>
                }
              </div>
            </div>
            <div className="column large-5 ">
              <div className="field-text">
                <Text style={labelStyle}> {messages['app.docsign.filter.rmTeam.label']} </Text>
              </div>
              <div >
                <Dropdown
                  testID="ddn-filterModal-rmTeam-test"
                  className="large-12"
                  size='large'
                  selected={this.state.rmTeam}
                  options={rmTeams}
                  defaultLabel={messages['app.docsign.filter.selectrmTeam.label']}
                  onChange={option => {
                    this.onFilterChange(FILTER_MODAL_FIELD_NAME.RM_TEAM, option, () => this.handleApply())
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="row filterRowsMargin">
            {/* Adding one dropdown and text filter */}
            <div className="column large-5">
              <div className="field-text">
                <Text style={labelStyle}>  {messages['app.docsigncenter.docdetails.upload.date']} </Text>
              </div>
              <div className="date-input" >
                <FilterModalInputField
                  testID="date-filterModal-uploaddate-test"
                  type='date'
                  value={this.state.uploadDate}
                  defStartDate={moment().add(-1, 'year')}
                  defEndDate={moment()}
                  onChange={e => this.handleDate(FILTER_MODAL_FIELD_NAME.UPLOAD_DATE, e)}
                  userSelectionStart={this.state.uploadDate.from}
                  userSelectionEnd={this.state.uploadDate.to}
                />
              </div>
            </div>
            <div className="column large-5 ">
              <div className="field-text">
                <Text style={labelStyle}> {messages['app.docsign.filter.status']} </Text>
              </div>
              <div >
                <Dropdown
                  testID="ddn-filterModal-docStatus-test"
                  className="large-12"
                  size='large'
                  defaultLabel={messages['app.docsign.filter.selectStatus']}
                  selected={this.state.docStatus}
                  options={docStatusList}
                  onChange={option => {
                    this.onFilterChange(FILTER_MODAL_FIELD_NAME.DOCUMENT_STATUS, option, () => this.handleApply())
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="row filterRowsMargin">

            {/* Adding one dropdown and text filter */}
            <div className="column large-5">
              <div className="field-text">
                <Text style={labelStyle}>  {messages['app.docsigncenter.uploadDoc.dueDate.noSig.label']} </Text>
              </div>
              <div className="date-input" >
                <FilterModalInputField
                  testID="date-filterModal-dueDate-test"
                  type='date'
                  value={this.state.dueDate}
                  defStartDate={moment().add(-1, 'year')}
                  defEndDate={moment().add(1, 'year')}
                  onChange={e => this.handleDate(FILTER_MODAL_FIELD_NAME.DUE_DATE, e)}
                  userSelectionStart={this.state.dueDate.from}
                  userSelectionEnd={this.state.dueDate.to}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="btn">
          <Button disabled={!this.state.enableApply} size="large" onPress={this.onApplyClick}>
            {messages['app.docsign.filter.applyButton']}
          </Button>
        </div>
        <div className="btn">
          <Button size="large" tertiary onPress={this.onClearClick}>
            {messages['app.doscign.filter.clearButton']}
          </Button>

        </div>
      </div>)

  }
}

export default createContainer({
  $queries: {
    app: {
      config: {
        apiverion: true
      }
    },
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    auth: {
      userId: true
    },
    settings: {
      defaultEnvironment: true
    },
    searchRmName: { $call: 'docsigncenter.searchRmName' },
    searchClientName: { $call: 'docsigncenter.searchClientName' },
    searchOrderId: { $call: 'docsigncenter.searchOrderId' },
    searchDocumentName: { $call: 'docsigncenter.searchDocumentName' },
    setRetainFilterData: { $set: 'docsigncenter.retainFilterData' },
    setSearchedClientNameList: { $set: 'docsigncenter.searchedClientNameList' },
    setSearchedOrderIdList: { $set: 'docsigncenter.searchedOrderIdList' },
    setSearchedDocumentNameList: { $set: 'docsigncenter.searchedDocumentNameList' },
    setSearchedRmNameList: { $set: 'docsigncenter.searchedRmNameList' },
    docsigncenter: {
      documentTypeList: true,
      eligiblePfList: true,
      rmTeamList: true,
      searchedRmNameList: true,
      searchedClientNameList: true,
      searchedOrderIdList: true,
      searchedDocumentNameList: true,
      signedDate: true,
      uploadDate: true,
      dueDate: true,
      retainFilterData: true,
    }
  }
})(FilterModal);

export { FilterModal };